import { FormikProps, useFormikContext } from 'formik';
import { FieldType } from '../types';
import { useContext, useEffect } from 'react';
import { CommonDataContext } from '../../context';
import _ from 'lodash';
import { Box, Grid } from '@mui/material';

export const AuthorizationAndAcceptanceField = ({
  itemData,
  locale,
  externalData,
}: {
  itemData: FieldType;
  locale: string;
  externalData: any
}) => {
  const formik: FormikProps<any> = useFormikContext();
  const { publicAccount } = useContext(CommonDataContext);

  const tempateSettingsDisclosures = _.get(externalData.activeTemplate, "jsonSettings.disclosure");
  const { isIndividualApp } = externalData;
  const disclosureKey = isIndividualApp ? 'individual' : 'commercial';

  const {
    useDefaultAuthorizationAndAcceptanceText,
    authorizationAndAcceptanceText: fieldConfigAuthorizationLanguage }
    = itemData.config;
  const templateSettingsAuthorizationLanguage = _.get(tempateSettingsDisclosures, [disclosureKey, 'authorizationLanguage', locale], null);
  const vpAuthorizationLanguage = locale === 'es'
    ? publicAccount.vendorProfile?.dcrDisclosureLanguageSpanish
    : publicAccount.vendorProfile?.dcrDisclosureLanguage;

  const authorizationLanguageToShow = (!useDefaultAuthorizationAndAcceptanceText && fieldConfigAuthorizationLanguage) ||
    templateSettingsAuthorizationLanguage ||
    vpAuthorizationLanguage;

  useEffect(() => {
    if (itemData.config.displayed) {
      formik.setFieldValue('disclosure.authorizationLanguage', authorizationLanguageToShow);
    }
  }, [itemData.config.displayed, authorizationLanguageToShow]);

  if (!itemData.config.displayed) {
    return null;
  }

  return <Box
    component={Grid}
    item
    xs={12}
  >
    <div
      dangerouslySetInnerHTML={{
        __html: authorizationLanguageToShow,
      }}
    ></div>
  </Box>
};
